/* import __COLOCATED_TEMPLATE__ from './select-kit-collection.hbs.js'; */
import Component from "@ember/component";
import { service } from "@ember/service";
import { tagName } from "@ember-decorators/component";
import { modifier } from "ember-modifier";
import { disableBodyScroll, enableBodyScroll, locks } from "discourse/lib/body-scroll-lock";
const SelectKitCollection = dt7948.c(class SelectKitCollection extends Component {
  static {
    dt7948.g(this.prototype, "site", [service]);
  }
  #site = (dt7948.i(this, "site"), void 0);
  bodyScrollLock = modifier(element => {
    if (!this.site.mobileView) {
      return;
    }
    const isChildOfLock = locks.some(lock => lock.targetElement.contains(element));
    if (isChildOfLock) {
      disableBodyScroll(element);
    }
    return () => {
      if (isChildOfLock) {
        enableBodyScroll(element);
      }
    };
  });
}, [tagName("")]);
export default SelectKitCollection;